export default "__VITE_ASSET__0878c2a8__"